<!-- Author Name Link (only) -->
@if (author) {
  <a
    class="author-name-link"
    href="javascript:void(0)"
    (click)="toggleModal($event)">
    {{ getAuthorFullNameWithTitle() }}
  </a>
}

<!-- Modal for Author Details -->
@if (showModal) {
  <div class="author-modal"
    [style.top.px]="modalPosition.top"
    [style.left.px]="modalPosition.left">
    <div class="modal-content">
      <!-- Close button -->
      <button class="modal-close" (click)="closeModal()" type="button">
        <i class="fas fa-times"></i>
      </button>
      <!-- Author Name and Title -->
      <h5 class="modal-author-name">
        <strong>{{ getAuthorFullNameWithTitle() }}</strong>
      </h5>
      <!-- Divider -->
      <hr class="modal-divider">
      <!-- Author Details List -->
      <ul class="modal-list">
        <!-- Location Information -->
        @if (hasLocationInfo()) {
          <li>
            <i class="fas fa-map-marker-alt"></i>
            <span>{{ getAuthorLocation() }}</span>
          </li>
        }
        <!-- Email -->
        @if (author.email) {
          <li>
            <i class="fas fa-envelope"></i>
            <a href="javascript:void(0)" (click)="openEmail()">
              {{ author.email }}
            </a>
          </li>
        }
        <!-- Department (if different from institution) -->
        @if (author.department && author.department !== author.institution) {
          <li>
            <i class="fas fa-building"></i>
            <span>{{ author.department }}</span>
          </li>
        }
        <!-- ORCID -->
        @if (author.orcid) {
          <li>
            <i class="fab fa-orcid"></i>
            <a href="javascript:void(0)" (click)="openOrcid()" [title]="'author.orcidProfile' | translate">
              ORCID: {{ getOrcidDisplay() }}
            </a>
          </li>
        }
        <!-- Website -->
        @if (author.website) {
          <li>
            <i class="fas fa-globe"></i>
            <a href="javascript:void(0)" (click)="openWebsite()" [title]="'author.website' | translate">
              {{ 'author.personalWebsite' | translate }}
            </a>
          </li>
        }
        <!-- Affiliation -->
        @if (author.affiliation) {
          <li>
            <i class="fas fa-university"></i>
            <span>{{ author.affiliation }}</span>
          </li>
        }
      </ul>
      <!-- Additional Info -->
      @if (!hasLocationInfo() && !author.email && !author.orcid && !author.website) {
        <div class="modal-additional-info">
          <p>{{ 'author.noAdditionalInfo' | translate }}</p>
        </div>
      }
    </div>
  </div>
}

<!-- Modal backdrop -->
@if (showModal) {
  <div class="modal-backdrop" (click)="closeModal()"></div>
}